let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("2iqdN"), load("ffEVr"), load("c6MKV"), load("aZinD"), load("joJy8"), load("aHE9G"), load("9DDT5")]).then(() => parcelRequire('2TweP'));